export const generateUrl = (src, size) => {
    return src;
}